import { queryRef, executeQuery, mutationRef, executeMutation, validateArgs } from 'firebase/data-connect';

export const connectorConfig = {
  connector: 'js-sdk',
  service: 'aviation-information',
  location: 'northamerica-northeast1'
};

export const seedSigmetRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return mutationRef(dcInstance, 'SeedSigmet');
}
seedSigmetRef.operationName = 'SeedSigmet';

export function seedSigmet(dc) {
  return executeMutation(seedSigmetRef(dc));
}

export const listSigmetsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListSigmets');
}
listSigmetsRef.operationName = 'ListSigmets';

export function listSigmets(dc) {
  return executeQuery(listSigmetsRef(dc));
}

export const listFirSigmetsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListFIRSigmets', inputVars);
}
listFirSigmetsRef.operationName = 'ListFIRSigmets';

export function listFirSigmets(dcOrVars, vars) {
  return executeQuery(listFirSigmetsRef(dcOrVars, vars));
}

export const listFirsSigmetsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListFirsSigmets', inputVars);
}
listFirsSigmetsRef.operationName = 'ListFirsSigmets';

export function listFirsSigmets(dcOrVars, vars) {
  return executeQuery(listFirsSigmetsRef(dcOrVars, vars));
}

export const listFirsRef = (dc) => {
  const { dc: dcInstance} = validateArgs(connectorConfig, dc, undefined);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListFirs');
}
listFirsRef.operationName = 'ListFirs';

export function listFirs(dc) {
  return executeQuery(listFirsRef(dc));
}

export const listExistingSigmetIdsRef = (dcOrVars, vars) => {
  const { dc: dcInstance, vars: inputVars} = validateArgs(connectorConfig, dcOrVars, vars);
  dcInstance._useGeneratedSdk();
  return queryRef(dcInstance, 'ListExistingSigmetIds', inputVars);
}
listExistingSigmetIdsRef.operationName = 'ListExistingSigmetIds';

export function listExistingSigmetIds(dcOrVars, vars) {
  return executeQuery(listExistingSigmetIdsRef(dcOrVars, vars));
}

